var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgClaimReward(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F0D242",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.594 10.8L11.785 13.05a3.451 3.451 0 00-1.99 1.186A3.466 3.466 0 009 16.413v10.221a2.408 2.408 0 001.719 2.456c.346.102.71.124 1.067.064l14.808-2.233a3.466 3.466 0 001.99-1.192 3.48 3.48 0 00.796-2.181V13.32a2.409 2.409 0 00-.787-1.933 2.397 2.397 0 00-2-.587z",
    fill: "#998273"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.041 19.993a5.49 5.49 0 005.484-5.497A5.49 5.49 0 0022.04 9a5.49 5.49 0 00-5.483 5.496 5.49 5.49 0 005.483 5.497z",
    fill: "#FFD34D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.994 14.547H12.006c-.796 0-1.56.316-2.123.88A3.016 3.016 0 009 17.552v10.434c.002.799.32 1.564.882 2.129a3.01 3.01 0 002.124.884h15.988a3.01 3.01 0 002.123-.884c.564-.565.881-1.33.883-2.129V17.552a3.016 3.016 0 00-.883-2.125 3.002 3.002 0 00-2.123-.88z",
    fill: "#BFA28F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.24 14.547L9 22.453V17.31a2.769 2.769 0 011.707-2.555 2.75 2.75 0 011.057-.208H24.24z",
    fill: "#D9B8A2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.622 20.92h-2.537a.602.602 0 01-.623-.603v-2.543a1.472 1.472 0 00-1.466-1.47 1.464 1.464 0 00-1.466 1.47v2.543a.603.603 0 01-.601.602h-2.515a1.464 1.464 0 00-1.466 1.47 1.471 1.471 0 001.466 1.47h2.537a.6.6 0 01.579.573v2.571a1.471 1.471 0 001.466 1.47 1.465 1.465 0 001.466-1.47v-2.571a.595.595 0 01.602-.603H24.6a1.465 1.465 0 001.466-1.47 1.472 1.472 0 00-1.444-1.44z",
    fill: "#998273"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.622 21.778h-2.537a.6.6 0 01-.6-.602v-2.55a1.472 1.472 0 00-1.467-1.47 1.464 1.464 0 00-1.466 1.47v2.55a.603.603 0 01-.601.602h-2.537a1.464 1.464 0 00-1.466 1.47 1.471 1.471 0 001.466 1.47h2.537a.6.6 0 01.601.595v2.55a1.471 1.471 0 001.466 1.469 1.465 1.465 0 001.466-1.47v-2.55a.597.597 0 01.601-.595h2.537a1.465 1.465 0 001.466-1.47 1.472 1.472 0 00-.905-1.357 1.464 1.464 0 00-.561-.112z",
    fill: "#FFD34D"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 9)",
    d: "M0 0h22v22H0z"
  })))));
}
export default SvgClaimReward;